export default "__VITE_ASSET__3c6d4308__"